module.exports = __webpack_public_path__ + "img/notifications-24px.174a1ed3.svg";